import { Button, buttonClasses, CircularProgress, styled } from '@mui/material';

const StyledButtond = styled(Button)(({ theme, color }) => ({
    maxHeight: { xs: '40px', md: '40px' },
    borderRadius: "8px",
    backgroundColor: "#FFFFFF",
    color: "#FFFFFF",
    fontWeight: "500",
    fontSize: "14px",
    minWidth: "150px",
    paddingLeft: "16px",
    paddingRight: "16px",
}));

function SearchButton({ title, rightIcon, ...props }) {
    return (
        <StyledButtond loadingIndicator={<CircularProgress size={15} sx={{ color: "#FFFFFF" }} />}  {...props}>
            {title}
            {rightIcon}
        </StyledButtond>
    )
}

export default SearchButton